module.exports = __webpack_public_path__ + "img/3.5fa40219.png";